import { useEffect } from 'react'

import { useLocalStorage } from '@front/logic/hooks'

export const useSetAccessTokenFromCookie = (): void => {
  const [accessToken, setAccessToken] = useLocalStorage('accessToken')

  useEffect(() => {
    // Retrieve token cookie when navigating from other service - mostly serviceapp - to hublo-front
    const getCookie = (name: string): string | undefined => {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) {
        return parts.pop()?.split(';').shift()
      }

      return undefined
    }

    if (accessToken === null || accessToken === '') {
      setAccessToken(getCookie('token') || '')
    }
  }, [accessToken, setAccessToken])
}
